import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

export default function PaginationRounded({ count, page, handleChange }) {
  
  const changePage = (event, value) => {
    handleChange(value);
  };

  return (
    <Stack spacing={2}>
      <Pagination size={'large'} count={count} shape="rounded" page={page} onChange={changePage} />
    </Stack>
  );
}